<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    莲花西站<br>
站点介绍<br>
莲花西站位于新洲路与红荔路交叉路口的东南侧主要位于绿化带内，斜穿福中一路，大致呈南北走向。 北侧为莲花山、深圳市地震局、深圳晚报社、深圳市景龙小学、香荔新村；南侧为华强职业技术学校、香蜜三村、福田区地税局。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:17	23:57	2号线	2分35秒	5分45秒<br>
莲塘	06:04	23:43	2号线	2分35秒	5分45秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:21	23:56	2号线	4分钟	5分钟<br>
莲塘	06:04	23:43	2号线	4分钟	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:21	00:46	2号线	4分钟	5分钟<br>
莲塘	06:04	00:43	2号线	4分钟	5分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
新洲路东侧（北）、福中一路北侧、红荔路、深圳市地震局 、儿童医院、鲁班大厦、莲花山公园、香蜜三村、天健名苑 、华茂欣园<br><br>
B出入口:<br>
新洲路、福中一路、华强职业技术学校、黄埔学校中学部<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 莲花山西①<br>
m105、322路、236路、m173<br><br>
B出入口:<br>
公交站名： 华强职校<br>
73、236、322、324、M105、M391、M499<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>